import BTCPAY from 'assets/icons/btcpay.svg';
import IBEX from 'assets/icons/IBEX_Logo_04.png';
import OpenNode from 'assets/icons/opennode.svg';

export const providers = {
    opennode: {
        name: "OpenNode",
        h1: "No-Hassle Setup",
        p: "Powered by ",
        img: OpenNode,
        label: "Powered by OpenNode and designed specifically for Oshi merchants, this integration enables you to effortlessly accept bitcoin payments, with the option to convert some or all of each sale back to your local currency.",
        benefits: [
            { desc: "Start Selling Now", active: true },
            { desc: "Automatic Currency Conversion", active: true }
        ],
        class: "ln-service-card",
        logoContainer: "logo-container opennode",
        slogan: "Bitcoin Payments at the Speed of Now."
    },
    ibex: {
        name: "IBEX",
        h1: "No-Hassle Setup",
        p: "Powered by ",
        img: IBEX,
        label: "Powered by Ibex, this seamless integration allows you to accept bitcoin payments instantly. ",
        benefits: [
            { desc: "Start Selling Now", active: true },
            { desc: "Low Fees", active: true },
            { desc: "Automatic Currency Conversion", active: false }
        ],
        class: "ln-service-card ibex",
        logoContainer: "logo-container ibex",
        slogan: "We make Bitcoin easy."
    },
    btcpay: {
        name: "BTCPay",
        h1: "For Shadowy Super Coders",
        p: "Powered by ",
        img: BTCPAY,
        label: "BTCPay Server is a free and open source server for merchants wanting to accept Bitcoin for their business. ",
        benefits: [
            { desc: "Self-hosted & open-source ", active: true },
            { desc: "Secure & private", active: true },
            {
                desc: "Censorship-resistant & free", active: true
            }
        ],
        class: "ln-service-card ibex",
        logoContainer: "logo-container ibex",
        slogan: "Self-Hosted Bitcoin Payment Gateway."
    }
}